var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReporte(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "15.252808px",
    viewBox: "0 0 16 15.252808",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L16 0L16 15.2528L0 15.2528L0 0Z",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mas-informacion"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L16 0L16 15.2528L0 15.2528L0 0Z",
    id: "Fondo",
    fill: "#FFFFFF",
    fillOpacity: 0,
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.0041199 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2678 2.27284e-07L4.98756 2.27284e-07C4.86322 2.27284e-07 4.74403 0.0470694 4.65609 0.1309L0.137344 4.43865C0.0494375 4.52245 0 4.6361 0 4.75461L0 13.6094C0 14.5156 0.773375 15.2528 1.724 15.2528L12.2677 15.2528C13.2183 15.2528 13.9917 14.5156 13.9917 13.6094L13.9917 1.64346C13.9917 0.737258 13.2183 0 12.2678 0L12.2678 2.27284e-07ZM4.51881 1.52572L4.51881 3.55807C4.51881 3.97147 4.16596 4.30781 3.73231 4.30781L1.60043 4.30781L4.51881 1.52572ZM13.0542 13.6094C13.0542 14.0228 12.7014 14.3591 12.2678 14.3591L1.72403 14.3591C1.29037 14.3591 0.937531 14.0228 0.937531 13.6094L0.937531 5.20147L3.73234 5.20147C4.68297 5.20147 5.45634 4.46421 5.45634 3.55801L5.45634 0.893718L12.2678 0.893718C12.7015 0.893718 13.0542 1.23005 13.0542 1.64346L13.0542 13.6094L13.0542 13.6094Z",
    id: "Forma",
    fill: "#404040",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5105 11.4873L3.48128 11.4873C3.22237 11.4873 3.01253 11.6874 3.01253 11.9342C3.01253 12.1809 3.22237 12.381 3.48128 12.381L10.5105 12.381C10.7693 12.381 10.9792 12.1809 10.9792 11.9342C10.9792 11.6874 10.7693 11.4873 10.5105 11.4873L10.5105 11.4873Z",
    id: "Forma",
    fill: "#404040",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5105 9.57279L3.48128 9.57279C3.22237 9.57279 3.01253 9.77287 3.01253 10.0197C3.01253 10.2664 3.22237 10.4665 3.48128 10.4665L10.5105 10.4665C10.7693 10.4665 10.9792 10.2664 10.9792 10.0197C10.9792 9.77287 10.7693 9.57279 10.5105 9.57279L10.5105 9.57279Z",
    id: "Forma",
    fill: "#404040",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5105 7.65816L3.48128 7.65816C3.22237 7.65816 3.01253 7.85824 3.01253 8.10502C3.01253 8.35181 3.22237 8.55188 3.48128 8.55188L10.5105 8.55188C10.7693 8.55188 10.9792 8.35181 10.9792 8.10502C10.9792 7.85824 10.7693 7.65816 10.5105 7.65816L10.5105 7.65816Z",
    id: "Forma",
    fill: "#404040",
    fillRule: "evenodd",
    stroke: "none"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReporte);
export default __webpack_public_path__ + "static/media/reporte.f5b341c3cef0c89195a4468a6fd583be.svg";
export { ForwardRef as ReactComponent };